export const Login = '/';
export const Dashboard = '/dashboard';
